/**
 * Cookie names.
 */
class C_Local
{
    constructor()
    {
        this.SOUND_ENABLED = "SOUND_ENABLED";
        this.MUSIC_ENABLED = "MUSIC_ENABLED";
    }
}

export default (new C_Local);